// extracted by mini-css-extract-plugin
export default {"rateModal":"RateModal_rateModal__XwGXy","modalContent":"RateModal_modalContent__WyRkT"};